/* cf-header-drawer.js — confort clavier et défilement pour le menu mobile.

   Le drawer est un <details> : il s'ouvre, se ferme et se navigue au clavier
   sans une ligne de JS. Ce fichier n'ajoute que deux choses qu'un <details>
   ne sait pas faire seul — fermer sur Échap et empêcher le fond de défiler. */

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;

  const open = document.querySelector('[data-cf-drawer][open]');
  if (!open) return;

  open.removeAttribute('open');
  open.querySelector('summary')?.focus();
});

document.addEventListener(
  'toggle',
  (event) => {
    const drawer = event.target;
    if (!drawer.matches?.('[data-cf-drawer]')) return;

    document.documentElement.style.overflow = drawer.open ? 'hidden' : '';
  },
  true
);
